import { AssignmentRowType } from '@shared/components/grids/rows/assignments/assignment-row-type.enum';

export class RowPriorityHelper {
  private static readonly rowTypePriorityMap = {
    [AssignmentRowType.RequestedResource]: 2,
    [AssignmentRowType.Assignment]: 1,
    [AssignmentRowType.UnassignedAssignment]: 0,
    [AssignmentRowType.TimeOff]: 0
  };

  public static getPriorityFromType(rowType: AssignmentRowType) {
    return this.rowTypePriorityMap[rowType];
  }
}
